export default {
  list: "Listing",
  out_of: "out of",
}
